export default "__VITE_ASSET__1e$Gqy36__"